import React from "react";
import { Row, Col } from 'react-bootstrap';

import FeatureServicesItemInline from './featureservices-iteminline';

function FeatureServicesItems(props) {
    const items = props.featureServicesItems;
    const itemsDetails = items.map(( item, index ) =>
        // Key should be specified inside the array.
        <Col key={ item.title.toString() } md={12}>
            <FeatureServicesItemInline
                key={ item.title.toString() }
                value={ item }  
                index={ index }
                />
        </Col>
    );
    return (
        <Row>
            { itemsDetails }
        </Row>
    );
}

export default class FeatureServicesInline extends React.Component {
    render() {
        return (
            <FeatureServicesItems featureServicesItems={ this.props.content }/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/features/featureservicesinline.jsx